import { useTranslation } from 'react-i18next';

import { DriveCardShell, DriveCardAction } from './drive_card_shell.component';
import { FolderIcon } from './folder_icon.component';


interface FolderCardProps {
  name: string;
  elementCount: number;
  lastModified?: Date | string;
  actions?: DriveCardAction[];
  onClick?: () => void;
}

export function FolderCard( { name, elementCount, lastModified, actions, onClick }: FolderCardProps ) {
  const { t } = useTranslation();

  const subtitle = elementCount === 0
    ? t( 'translation:0_items' )
    : elementCount === 1
      ? t( 'translation:1_item' )
      : `${ elementCount } ${ t( 'translation:items' ) }`;

  return (
    <DriveCardShell
      icon={
        <FolderIcon
          isEmpty={ elementCount === 0 }
          className={ `w-16 h-16 ${ elementCount === 0 ? 'text-orange-400' : 'text-red-500' }` }
        />
      }
      name={ name }
      subtitle={ subtitle }
      lastModified={ lastModified }
      actions={ actions }
      onClick={ onClick }
    />
  );
}
